"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[351],{

/***/ 727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_cool_inview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5276);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5722);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Photo = function(param) {
    var photo = param.photo, width = param.width, height = param.height, _srcSizes = param.srcSizes, srcSizes = _srcSizes === void 0 ? [
        400,
        600,
        800,
        1000,
        1200,
        1600,
        1800,
        2000,
        2200,
        2400,
        2600,
        2800, 
    ] : _srcSizes, _sizes = param.sizes, sizes = _sizes === void 0 ? "(min-width: 940px) 100vw, 100vw" : _sizes, _layout = param.layout, layout = _layout === void 0 ? "intrinsic" : _layout, _quality = param.quality, quality = _quality === void 0 ? 100 : _quality, _hasPlaceholder = param.hasPlaceholder, hasPlaceholder = _hasPlaceholder === void 0 ? true : _hasPlaceholder, forceLoad = param.forceLoad, onLoad = param.onLoad, className = param.className;
    var handleLoad = // handle our image onLoad
    function handleLoad() {
        requestAnimationFrame(function() {
            setIsLoaded(true);
        });
    };
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoaded = ref1[0], setIsLoaded = ref1[1];
    var ref2 = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
        unobserveOnEnter: true,
        threshold: 0,
        rootMargin: "500px"
    }), observe = ref2.observe, inView = ref2.inView;
    // trigger any onLoad callbacks
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isLoaded || forceLoad) onLoad === null || onLoad === void 0 ? void 0 : onLoad();
    }, [
        isLoaded,
        forceLoad,
        onLoad
    ]);
    if (!(photo === null || photo === void 0 ? void 0 : photo.asset)) return null;
    // define our aspect ratio if not a background fill
    var aspect = typeof width === "number" && typeof height === "number" ? height / width * 100 : 100 / (photo.customRatio || photo.aspectRatio);
    var aspectCustom = layout === "intrinsic" || layout === "static" ? {
        paddingTop: "".concat(aspect, "%")
    } : null;
    // define our src and srcset
    var src = (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_4__/* .buildSrc */ .ZA)(photo, _objectSpread({}, {
        width: width
    }, {
        height: height
    }, {
        quality: quality
    }));
    var srcset = (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_4__/* .buildSrcSet */ .fY)(photo, _objectSpread({}, {
        srcSizes: srcSizes
    }, {
        aspect: aspect
    }, {
        quality: quality
    }));
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
        className: className ? className : null,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("ar", {
                "has-fill": layout === "fill" || layout === "contain",
                "mix-blend-multiply transform-gpu relative z-[1]": photo.mixBlendMode === "multiply"
            }),
            style: aspectCustom,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("picture", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        ref: observe,
                        width: width,
                        height: height,
                        src: forceLoad || inView ? src : null,
                        srcSet: forceLoad || inView ? srcset : null,
                        sizes: sizes,
                        decoding: "async",
                        onLoad: handleLoad,
                        alt: photo.alt || ((ref = photo.asset) === null || ref === void 0 ? void 0 : ref.altText),
                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(getSize(layout), {
                            "is-loaded": isLoaded
                        }),
                        style: {
                            objectPosition: photo.hotspot ? "".concat(photo.hotspot.x * 100, "% ").concat(photo.hotspot.y * 100, "%") : null
                        }
                    })
                }),
                hasPlaceholder && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("ar--placeholder", {
                        "is-loaded": isLoaded
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: photo.lqip,
                        alt: "",
                        role: "presentation"
                    })
                })
            ]
        })
    }));
};
var getSize = function(layout) {
    switch(layout){
        case "static":
            return "static";
        case "intrinsic":
            return "object-cover";
        case "fill":
            return "object-cover";
        case "contain":
            return "object-contain";
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (Photo);


/***/ }),

/***/ 1995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_photo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(727);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6513);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6139);
/* harmony import */ var react_cool_inview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5276);






var generateKey = function(pre) {
    return "".concat(pre, "_").concat(new Date().getTime());
};
var Phrase = function(param1) {
    var phrase = param1.phrase, _phraseMaxWidth = param1.phraseMaxWidth, phraseMaxWidth = _phraseMaxWidth === void 0 ? "none" : _phraseMaxWidth, _typeStyle = param1.typeStyle, typeStyle = _typeStyle === void 0 ? false : _typeStyle, _wordStyle = param1.wordStyle, wordStyle = _wordStyle === void 0 ? false : _wordStyle, _dividerMaxWidth = param1.dividerMaxWidth, dividerMaxWidth = _dividerMaxWidth === void 0 ? false : _dividerMaxWidth, _verticalEndHeight = param1.verticalEndHeight, verticalEndHeight = _verticalEndHeight === void 0 ? 0 : _verticalEndHeight, _color = param1.color, color = _color === void 0 ? "#000000" : _color, _vertical = param1.vertical, vertical = _vertical === void 0 ? false : _vertical, _hideLast = param1.hideLast, hideLast = _hideLast === void 0 ? false : _hideLast, _sectionHeightRef = param1.sectionHeightRef, sectionHeightRef = _sectionHeightRef === void 0 ? false : _sectionHeightRef, _customThreshold = param1.customThreshold, customThreshold = _customThreshold === void 0 ? false : _customThreshold, _delay = param1.delay, delay = _delay === void 0 ? 0 : _delay, _duration = param1.duration, duration = _duration === void 0 ? 2 : _duration, _ease = param1.ease, ease = _ease === void 0 ? "easeInOut" : _ease, _reverse = param1.reverse, reverse = _reverse === void 0 ? false : _reverse, _isStatic = param1.isStatic, isStatic = _isStatic === void 0 ? false : _isStatic, _noAnim = param1.noAnim, noAnim = _noAnim === void 0 ? false : _noAnim;
    var wordVariants = {
        visible: {
            opacity: 1,
            transition: {
                duration: 1,
                ease: "easeInOut"
            }
        },
        hidden: {
            opacity: 1
        }
    };
    var horizontalLineVariants = !reverse ? {
        visible: {
            opacity: 1,
            maxWidth: dividerMaxWidth ? dividerMaxWidth : "100px",
            transition: {
                duration: duration,
                delay: delay,
                ease: ease
            }
        },
        hidden: {
            opacity: 1,
            maxWidth: 0
        }
    } : {
        hidden: {
            opacity: 1,
            maxWidth: dividerMaxWidth ? dividerMaxWidth : "100px"
        },
        visible: {
            opacity: 1,
            maxWidth: 0,
            transition: {
                duration: duration,
                delay: delay,
                ease: ease
            }
        }
    };
    var verticalLineVariants = {
        visible: {
            opacity: 1,
            maxHeight: verticalEndHeight,
            transition: {
                duration: duration,
                delay: delay,
                ease: ease
            }
        },
        hidden: {
            opacity: 1,
            maxHeight: dividerMaxWidth ? dividerMaxWidth : "1000px"
        }
    };
    var verticalLineVariantsLast = {
        visible: {
            opacity: 1,
            maxHeight: "175px",
            transition: {
                duration: 3,
                delay: delay,
                ease: ease
            }
        },
        hidden: {
            opacity: 1,
            maxHeight: dividerMaxWidth ? dividerMaxWidth : "1000px"
        }
    };
    var controls = (0,framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .useAnimation */ ._)();
    var ref = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        rootMargin: "-100px 0px",
        threshold: customThreshold ? customThreshold : [
            0.2,
            0.4,
            0.6
        ],
        onEnter: function(param) {
            var scrollDirection = param.scrollDirection;
            if (scrollDirection.vertical == "up" && !isStatic) {
                controls.start("visible");
            }
        }
    }, [
        controls
    ]), observe = ref.observe, unobserve = ref.unobserve, inView = ref.inView, scrollDirection1 = ref.scrollDirection, entry = ref.entry;
    if (inView && !isStatic) {
        controls.start("visible");
    }
    if (!phrase) return null;
    var phraseWords = phrase.split("-");
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("phrase", "flex", "w-full", "mx-auto", "justify-center", "items-center", "relative", typeStyle, {
            "flex-col": vertical,
            "max-w-[96vw]": phraseMaxWidth == "none",
            "pb-[50px] mb-[8px]": isStatic
        }),
        style: {
            maxWidth: phraseMaxWidth !== "none" ? phraseMaxWidth : "none"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: observe,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute", "top-0", "w-full", "mb-20", {
                    "h-screen": sectionHeightRef
                })
            }),
            isStatic && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-[1px]", "h-[100%]", "bg-black", "absolute", "z-10", "top-0", "fake-line")
            }),
            phraseWords.map(function(word, idx) {
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_6__.m.div, {
                            variants: wordVariants,
                            animate: controls,
                            initial: "hidden",
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("inline-flex", "items-center", "px-gutter", "relative", {
                                "flex-col md:pb-0": vertical,
                                "sticky sticky-phrase z-20": isStatic,
                                "top-[30vh]": isStatic && idx == 0,
                                "pb-[44px] md:pb-[70px]": isStatic && idx == 0 && phraseWords.length > 1,
                                "top-[calc(30vh+44px)] md:top-[calc(30vh+70px)]": isStatic && idx == 1
                            }),
                            children: [
                                word.trim().length > 0 && idx == 0 && isStatic && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute", "backdrop", "outline-0", "bottom-[0px]", "left-0", "w-full", "h-[800px]", "pointer-events-none", "flex", {
                                        "bottom-[58px]": isStatic && idx == 0 && phraseWords.length > 1
                                    })
                                }),
                                word.trim().length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("block", {
                                        "md:whitespace-nowrap": !vertical,
                                        "pt-0 relative z-10 pb-0 mb-0 mt-full": isStatic,
                                        "md:mb-0": !isStatic && idx == 0 && phraseWords.length == 2,
                                        "mb-[0px]": isStatic && idx == 0 && phraseWords.length == 2,
                                        "mb-[8px] md:mb-0": !isStatic && idx == 0 && phraseWords.length == 2 && vertical
                                    }),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(wordStyle, {
                                            "bg pb-0 block relative mb-0 overflow-hidden": isStatic
                                        }),
                                        children: word.trim()
                                    })
                                })
                            ]
                        }, "".concat(idx, "-").concat(word.trim())),
                        idx !== phraseWords.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__.m.div, {
                            animate: controls,
                            initial: noAnim ? "visible" : "hidden",
                            variants: !vertical ? horizontalLineVariants : idx == 0 && word.trim() == "" ? verticalLineVariantsLast : verticalLineVariants,
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("divider", {
                                "w-[2000px] h-[1px]": !vertical,
                                "h-[250px] md:h-[500px] w-[1px]": vertical,
                                "mt-[-70px]": isStatic && idx == 0 && phraseWords.length > 1
                            }),
                            style: {
                                backgroundColor: color
                            }
                        }, "".concat(idx, "-line"))
                    ]
                }));
            }),
            vertical && !hideLast && phrase !== "-" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__.m.div, {
                animate: controls,
                initial: "hidden",
                variants: !vertical ? horizontalLineVariants : verticalLineVariantsLast,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("divider", "mb-gutter", {
                    "w-[1000px] h-[1px]": !vertical,
                    "h-[250px] md:h-[500px] w-[1px]": vertical
                }),
                style: {
                    backgroundColor: color
                }
            }, "final-".concat(generateKey("line")))
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Phrase);


/***/ }),

/***/ 5276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports observerErr, observerWarn */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var useLatest = (function (val) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(val);
  ref.current = val;
  return ref;
});

var observerErr = "💡 react-cool-inview: the browser doesn't support Intersection Observer, please install polyfill: https://github.com/wellyshen/react-cool-inview#intersection-observer-polyfill";
var observerWarn = "💡 react-cool-inview: the browser doesn't support Intersection Observer v2, fallback to v1 behavior";

var useInView = function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      root = _ref.root,
      rootMargin = _ref.rootMargin,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 0 : _ref$threshold,
      trackVisibility = _ref.trackVisibility,
      delay = _ref.delay,
      unobserveOnEnter = _ref.unobserveOnEnter,
      onChange = _ref.onChange,
      onEnter = _ref.onEnter,
      onLeave = _ref.onLeave;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    inView: false,
    scrollDirection: {}
  }),
      state = _useState[0],
      setState = _useState[1];

  var prevInViewRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var prevPosRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
  var observerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var warnedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var onChangeRef = useLatest(onChange);
  var onEnterRef = useLatest(onEnter);
  var onLeaveRef = useLatest(onLeave);
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var unobserve = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (observerRef.current) {
      observerRef.current.disconnect();
      prevPosRef.current = {};
    }
  }, []);
  var observe = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (element) {
    if (element && element !== ref.current) {
      unobserve();
      ref.current = element;
    }

    if (observerRef.current && ref.current) observerRef.current.observe(ref.current);
  }, [unobserve]);
  var updatePosition = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (!ref.current) return;

    var _ref$current$getBound = ref.current.getBoundingClientRect(),
        x = _ref$current$getBound.x,
        y = _ref$current$getBound.y;

    prevPosRef.current = {
      x: x,
      y: y
    };
  }, [ref]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!("IntersectionObserver" in window) || !("IntersectionObserverEntry" in window)) {
      console.error(observerErr);
      return function () {
        return null;
      };
    }

    var isActive = true; // eslint-disable-next-line compat/compat

    observerRef.current = new IntersectionObserver(function (_ref2) {
      var entry = _ref2[0];
      var intersectionRatio = entry.intersectionRatio,
          isIntersecting = entry.isIntersecting,
          _entry$boundingClient = entry.boundingClientRect,
          x = _entry$boundingClient.x,
          y = _entry$boundingClient.y,
          isVisible = entry.isVisible;
      var scrollDirection = {};
      var min = Array.isArray(threshold) ? Math.min.apply(Math, threshold) : threshold;
      var inView = isIntersecting !== undefined ? isIntersecting : intersectionRatio > 0;
      inView = min > 0 ? intersectionRatio >= min : inView; // @ts-expect-error

      if (x < prevPosRef.current.x) scrollDirection.horizontal = "left"; // @ts-expect-error

      if (x > prevPosRef.current.x) scrollDirection.horizontal = "right";
      prevPosRef.current.x = x; // @ts-expect-error

      if (y < prevPosRef.current.y) scrollDirection.vertical = "up"; // @ts-expect-error

      if (y > prevPosRef.current.y) scrollDirection.vertical = "down";
      prevPosRef.current.y = y;
      var e = {
        entry: entry,
        scrollDirection: scrollDirection,
        observe: observe,
        unobserve: unobserve
      };

      if (trackVisibility) {
        if (isVisible === undefined && !warnedRef.current) {
          console.warn(observerWarn);
          warnedRef.current = true;
        }

        if (isVisible !== undefined) inView = isVisible;
      }

      if (inView && !prevInViewRef.current) {
        if (unobserveOnEnter) unobserve();
        if (onEnterRef.current) onEnterRef.current(e);
      }

      if (!inView && prevInViewRef.current && onLeaveRef.current) onLeaveRef.current(e);
      if (onChangeRef.current) onChangeRef.current(_extends({}, e, {
        inView: inView
      }));
      if (isActive) setState({
        inView: inView,
        scrollDirection: scrollDirection,
        entry: entry
      });
      prevInViewRef.current = inView;
    }, {
      root: root,
      rootMargin: rootMargin,
      threshold: threshold,
      trackVisibility: trackVisibility,
      delay: delay
    });
    observe();
    return function () {
      isActive = false;
      unobserve();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unobserveOnEnter, root, rootMargin, // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(threshold), trackVisibility, delay, observe, unobserve]);
  return _extends({}, state, {
    observe: observe,
    unobserve: unobserve,
    updatePosition: updatePosition
  });
};




/***/ }),

/***/ 6513:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(4394);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/animation.mjs + 17 modules
var animation = __webpack_require__(8729);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(5759);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(6681);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ })

}]);